import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import SelectAutoComplete from "../../components/SelectAutoComplete";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/report/agent";
import Dialog from "./../../components/Dialog";
import { mapActionsToProps as agentAction } from "./../../redux/agent";
import { mapActionsToProps as campaignAction } from "./../../redux/campaigns";
import { mapActionsToProps as groupReportAction } from "./../../redux/report/group";

let dateTimeFromAndTo = true;
let dateTime = false;
let selectAgent = false;
let selectGroup = false;

class ReportPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      campaignId: null,
      selectReport: "",
      timeTo: null,
      timeFrom: null,
      agentGroupId: "",
      agentId: "all",
      reportDay: false,
      listAgents: [],
      selectedAgent: "",
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    this.props.getListCampaigns();
    this.props.getListGroupAgent();
    this.props.getListAgent("createdAt DESC", 999, null, null);
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listAgents)) !==
        JSON.parse(JSON.stringify(_.values(props.listAgents))) &&
      !state.listAgents
    ) {
      return {
        listAgents: _.values(props.listAgents),
      };
    }
    return null;
  }

  handleChange = (name) => {
    return (e) => {
      return this.setState(
        {
          [name]: e.target.value,
        },
        () => {
          switch (this.state.selectReport) {
            case "reportPerDay": {
              this.setState({
                timeTo: datetimeHelper.toFormat(
                  this.state.timeFrom,
                  "YYYY-MM-DD"
                ),
                agentId: "",
                agentGroupId: "",
                reportDay: true,
              });
              break;
            }
            case "reportByDay": {
              this.setState({
                agentId: "",
                agentGroupId: "",
                reportDay: true,
              });
              break;
            }

            case "reportByGroup": {
              this.setState({
                agentId: "",
                reportDay: false,
              });
              break;
            }
            case "reportByAgent": {
              this.setState({
                agentGroupId: "",
                reportDay: false,
                agentId: "all",
              });
              break;
            }
            default:
              break;
          }
        }
      );
    };
  };

  handleChangeAgentId = (e) => {
    this.setState({
      agentId: e.target.value,
    });
  };

  handleSubmit = (e) => {
    const { timeFrom, timeTo } = this.state;
    let gte = datetimeHelper.toFormat(timeFrom, "YYYY-MM-DD startDay");
    let lte = datetimeHelper.toFormat(timeTo, "YYYY-MM-DD endDay");
    switch (this.state.selectReport) {
      case "reportByDay": {
        this.props.getListReportAgentPerformence(gte, lte);
        break;
      }
      case "reportPerDay": {
        this.props.getListReportAgentPerformence(gte, lte);
        break;
      }
      case "reportByGroup": {
        this.props.getListReportAgentAndGroupPerformence(
          gte,
          lte,
          this.state.selectedAgent,
          this.state.agentGroupId
        );
        break;
      }
      case "reportByAgent": {
        this.props.getListReportAgentAndGroupPerformence(
          gte,
          lte,
          this.state.selectedAgent ? this.state.selectedAgent : "",
          this.state.agentGroupId
        );
        break;
      }
      default:
        break;
    }
  };

  handleDateChangeStart = (start) => {
    this.setState(
      {
        timeFrom: datetimeHelper.toFormat(start, "YYYY-MM-DD"),
      },
      () => {
        switch (this.state.selectReport) {
          case "reportPerDay":
          case "reportByDay": {
            this.setState({
              timeFrom: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD startDay"
              ),
              timeTo: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD endDay"
              ),
              agentId: "",
              agentGroupId: "",
              reportDay: true,
            });
            break;
          }
          case "reportByGroup": {
            this.setState({
              timeFrom: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD startDay"
              ),
              timeTo: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD endDay"
              ),
              agentId: "",
              reportDay: false,
            });
            break;
          }
          case "reportByAgent": {
            this.setState({
              timeFrom: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD startDay"
              ),
              timeTo: datetimeHelper.toFormat(
                this.state.timeFrom,
                "YYYY-MM-DD endDay"
              ),
              agentGroupId: "",
              reportDay: false,
            });
            break;
          }
          default:
            break;
        }
      }
    );
  };

  handleDateChangeEnd = (end) => {
    this.setState({ timeTo: datetimeHelper.toFormat(end, "YYYY-MM-DD") });
  };

  handleCampaignDetailReport(item) {
    this.setState({
      openModal: true,
      item: item,
    });
  }

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  _export;
  export = () => {
    this._export.save();
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              (item &&
                item.code &&
                item.code.toLowerCase().includes(search.toLowerCase())) ||
              (item &&
                item.user &&
                item.user.fullname &&
                item.user.fullname.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  handleSearchUser = (text) => {
    const { listAgents } = this.props;
    this.setState({
      listAgents: this.filterCustomers(_.values(listAgents), text),
    });
  };

  render() {
    const {
      classes,
      listReportPerformance,
      listAgents,
      listAgentGroups,
      listReportAgentAndGroup,
    } = this.props;
    const listReportAgentAndGroupResult =
      typeof listReportAgentAndGroup === "object"
        ? Object.keys(listReportAgentAndGroup).map(
            (key) => listReportAgentAndGroup[key]
          )
        : listReportAgentAndGroup;
    const listReportPerformanceResult =
      typeof listReportPerformance === "object"
        ? Object.keys(listReportPerformance).map(
            (key) => listReportPerformance[key]
          )
        : listReportPerformance;
    const listAgentsResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const dataReport = [
      ["Mã nhân viên", "Tổng số cuộc kết nối", "Tổng thời gian thoại"],
    ];
    const dataReportByPercent = [
      [
        "Mã nhân viên",
        "Thời gian chờ ngắn nhất",
        "Thời gian chờ dài nhất",
        "Thời gian thoại trung bình",
      ],
    ];
    const outboundReport = [
      [
        "Máy lẻ",
        "Tổng cuộc gọi kết nối",
        "Số cuộc không trả lời",
        "Số cuộc bận",
      ],
    ];
    const outboundReportAgent = [
      [
        "Máy lẻ",
        "Tổng cuộc gọi kết nối",
        "Số cuộc không trả lời",
        "Số cuộc bận",
      ],
    ];
    for (const key in listReportPerformanceResult) {
      if (listReportPerformanceResult.hasOwnProperty(key)) {
        const value = listReportPerformanceResult[key];
        if (value.agent.code !== "Total") {
          outboundReport.push([
            value.agent.code,
            value.totalConnect ? value.totalConnect : 0,
            value.noAnsweredCalls ? value.noAnsweredCalls : 0,
            value.busyCalls ? value.busyCalls : 0,
          ]);
        }
      }
    }

    for (const key in listReportAgentAndGroupResult) {
      if (listReportAgentAndGroupResult.hasOwnProperty(key)) {
        const value = listReportAgentAndGroupResult[key];
        if (value.agent.code !== "Total") {
          outboundReportAgent.push([
            value.agent.code,
            value.totalConnect ? value.totalConnect : 0,
            value.noAnsweredCalls ? value.noAnsweredCalls : 0,
            value.busyCalls ? value.busyCalls : 0,
          ]);
        }
      }
    }

    for (const key in listReportPerformanceResult) {
      if (listReportPerformanceResult.hasOwnProperty(key)) {
        const value = listReportPerformanceResult[key];
        if (value.agent.code !== "Total") {
          dataReport.push([
            value.agent.code,
            value.totalConnect,
            datetimeHelper.msToMinu(value.totalTalkingTime),
          ]);
          dataReportByPercent.push([
            value.agent.code,
            datetimeHelper.secondToMinutes(value.minWrapupTime),
            datetimeHelper.secondToMinutes(value.maxWrapupTime),
            datetimeHelper.secondToMinutes(value.avgWrapupTime),
          ]);
        }
      }
    }
    switch (this.state.selectReport) {
      case "reportByDay": {
        dateTimeFromAndTo = true;
        selectAgent = false;
        selectGroup = false;
        dateTime = false;
        break;
      }
      case "reportPerDay": {
        dateTimeFromAndTo = false;
        selectAgent = false;
        selectGroup = false;
        dateTime = true;
        break;
      }
      case "reportByGroup": {
        dateTimeFromAndTo = true;
        selectAgent = false;
        selectGroup = true;
        dateTime = false;
        break;
      }
      case "reportByAgent": {
        dateTimeFromAndTo = true;
        selectAgent = true;
        selectGroup = false;
        dateTime = false;
        break;
      }

      default:
        break;
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Chọn báo cáo"
                          variant="outlined"
                          className={classes.input}
                          value={this.state.selectReport}
                          onChange={this.handleChange("selectReport")}
                          name="selectReport"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem value="reportByDay">
                            Báo cáo năng suất theo ngày
                          </MenuItem>
                          <MenuItem value="reportPerDay">
                            Báo cáo năng suất trong ngày
                          </MenuItem>
                          <MenuItem value="reportByGroup">
                            Báo cáo năng suất theo team
                          </MenuItem>
                          <MenuItem value="reportByAgent">
                            Báo cáo năng suất theo điện thoại viên
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      {dateTimeFromAndTo == true ? (
                        <React.Fragment>
                          <Grid item md={3}>
                            <InlineDatePicker
                              margin="normal"
                              label="Thời gian bắt đầu"
                              variant="outlined"
                              className={classes.input}
                              value={this.state.timeFrom}
                              format="dd-MM-yyyy"
                              onChange={this.handleDateChangeStart}
                              name="timeFrom"
                              keyboard
                              maxDate={new Date()}
                              required={true}
                              ampm={false}
                              validators={["required"]}
                              errorMessages={[`Không được để trống`]}
                            />
                          </Grid>
                          <Grid item md={3}>
                            <InlineDatePicker
                              margin="normal"
                              label="Thời gian kết thúc"
                              variant="outlined"
                              className={classes.input}
                              value={this.state.timeTo}
                              maxDate={new Date()}
                              minDate={this.state.timeFrom}
                              format="dd-MM-yyyy"
                              onChange={this.handleDateChangeEnd}
                              name="timeTo"
                              keyboard
                              required={true}
                              ampm={false}
                              validators={["required"]}
                              errorMessages={[`Không được để trống`]}
                            />
                          </Grid>
                        </React.Fragment>
                      ) : (
                        <React.Fragment />
                      )}
                      {selectAgent == true ? (
                        <Grid item md={3} container>
                          <Grid item md={7} style={{ marginTop: "16px" }}>
                            <SelectAutoComplete
                              label={"Mã điện thoại viên"}
                              data={
                                this.state.listAgents &&
                                this.state.listAgents.length > 0
                                  ? this.state.listAgents.map((val) => {
                                      return {
                                        id: val.id,
                                        label: val.user
                                          ? `${val.code} - ${val.user.fullname}`
                                          : "",
                                      };
                                    })
                                  : []
                              }
                              onSearch={debounce(
                                (text) => this.handleSearchUser(text),
                                300
                              )}
                              onChange={(item) => {
                                this.setState(
                                  {
                                    selectedAgent: item ? item.id : "",
                                  },
                                  () => {
                                    this.handleSubmit();
                                  }
                                );
                              }}
                              className={classes.input}
                              onClear={true}
                              name="agentId"
                            />
                          </Grid>
                          <Grid item md={5} style={{ display: "flex" }}>
                            <Tooltip title="Tìm kiếm" disableFocusListener>
                              <Fab
                                color="primary"
                                aria-label="Search"
                                className={classes.fab}
                                // onClick={this.handleSubmit}
                                type="submit"
                                style={{ marginTop: "15px" }}>
                                <Search />
                              </Fab>
                            </Tooltip>
                            <Tooltip title="Tải báo cáo" disableFocusListener>
                              <Fab
                                color="primary"
                                aria-label="Search"
                                style={{ marginTop: "15px" }}
                                className={classes.fab}
                                onClick={this.export}>
                                <Icon className={classes.add}>save_alt</Icon>
                              </Fab>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      ) : (
                        <React.Fragment />
                      )}
                      {selectGroup == true ? (
                        <Grid item md={3} container>
                          <Grid item md={7}>
                            <SelectValidator
                              id="outlined-full-width"
                              margin="normal"
                              label="Tên nhóm"
                              variant="outlined"
                              className={classes.input}
                              onChange={this.handleChange("agentGroupId")}
                              value={this.state.agentGroupId}
                              name="agentGroupId"
                              InputLabelProps={{
                                shrink: true,
                              }}>
                              <MenuItem>
                                <em>Tất cả</em>
                              </MenuItem>
                              {listAgentGroupsResult
                                ? listAgentGroupsResult.map((item, key) => {
                                    return (
                                      <MenuItem key={key} value={item.id}>
                                        {item.name}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </SelectValidator>
                          </Grid>
                          <Grid item md={5} style={{ display: "flex" }}>
                            <Tooltip title="Tìm kiếm" disableFocusListener>
                              <Fab
                                color="primary"
                                aria-label="Search"
                                className={classes.fab}
                                // onClick={this.handleSubmit}
                                type="submit"
                                style={{ marginTop: "15px" }}>
                                <Search />
                              </Fab>
                            </Tooltip>
                            <Tooltip title="Tải báo cáo" disableFocusListener>
                              <Fab
                                color="primary"
                                aria-label="Search"
                                style={{ marginTop: "15px" }}
                                className={classes.fab}
                                onClick={this.export}>
                                <Icon className={classes.add}>save_alt</Icon>
                              </Fab>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      ) : (
                        <React.Fragment />
                      )}
                      {dateTime == true ? (
                        <Grid item md={3}>
                          <InlineDatePicker
                            margin="normal"
                            label="Thời gian"
                            variant="outlined"
                            className={classes.input}
                            value={this.state.timeFrom}
                            format="dd-MM-yyyy"
                            onChange={this.handleDateChangeStart}
                            name="timeFrom"
                            keyboard
                            maxDate={new Date()}
                            validators={["required"]}
                            errorMessages={[`Không được để trống`]}
                            required={true}
                          />
                        </Grid>
                      ) : (
                        <React.Fragment />
                      )}
                      <Grid
                        item
                        md={3}
                        style={{
                          display:
                            selectGroup || selectAgent ? "none" : "block",
                        }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            // onClick={this.handleSubmit}
                            type="submit"
                            style={{ marginTop: "15px" }}>
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginTop: "15px" }}
                            className={classes.fab}
                            onClick={this.export}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
              {this.state.reportDay == true ? (
                <ExcelExport
                  data={listReportPerformanceResult}
                  ref={(exporter) => (this._export = exporter)}
                  fileName="Báo cáo năng suất theo ngày">
                  <ExcelExportColumn
                    field="date"
                    title="Ngày"
                    locked={true}
                    width={50}
                  />
                  <ExcelExportColumn
                    field="agent.group"
                    title="Nhóm"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.code"
                    title="Mã điện thoại viên"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.subOrg"
                    title="Mã đơn vị"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.subOrgName"
                    title="Tên đơn vị"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="agent.subOrgBusiness"
                    title="Nghiệp vụ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="agent.fullname"
                    title="Tên điện thoại viên"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="calls"
                    title="Tổng số cuộc"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalConnect"
                    title="Tổng cuộc gọi kết nối"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="noAnsweredCalls"
                    title="Số cuộc không trả lời"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="busyCalls"
                    title="Số cuộc bận"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalTalkingTime"
                    title="Tổng thời gian thoại"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="acd"
                    title="Thời gian thoại trung bình"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="minWrapupTime"
                    title="Thời gian chờ ngắn nhất"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="maxWrapupTime"
                    title="Thời gian chờ dài nhất"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="avgWrapupTime"
                    title="Thời gian chờ trung bình"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalBreak"
                    title="Số lần nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalBreakTime"
                    title="Tổng thời gian nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalRespiteTime"
                    title="Tổng thời gian tạm nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalOnlineTime"
                    title="Tổng thời gian trực tuyến"
                    width={100}
                  />
                </ExcelExport>
              ) : (
                <ExcelExport
                  data={listReportAgentAndGroupResult}
                  ref={(exporter) => (this._export = exporter)}
                  fileName="Báo cáo năng suất theo team">
                  <ExcelExportColumn
                    field="date"
                    title="Ngày"
                    locked={true}
                    width={50}
                  />
                  <ExcelExportColumn
                    field="agent.group"
                    title="Nhóm"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.code"
                    title="Mã điện thoại viên"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.subOrg"
                    title="Mã đơn vị"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="agent.subOrgName"
                    title="Tên đơn vị"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="agent.subOrgBusiness"
                    title="Nghiệp vụ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="agent.fullname"
                    title="Tên điện thoại viên"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="calls"
                    title="Tổng số cuộc"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalConnect"
                    title="Tổng cuộc gọi kết nối"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="noAnsweredCalls"
                    title="Số cuộc bỏ qua"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="busyCalls"
                    title="Số cuộc bận"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalTalkingTime"
                    title="Tổng thời gian thoại"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="acd"
                    title="Thời gian thoại trung bình"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="minWrapupTime"
                    title="Thời gian chờ ngắn nhất"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="maxWrapupTime"
                    title="Thời gian chờ dài nhất"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="avgWrapupTime"
                    title="Thời gian chờ trung bình"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalBreak"
                    title="Số lần nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalBreakTime"
                    title="Tổng thời gian nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalRespiteTime"
                    title="Tổng thời gian tạm nghỉ"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="totalOnlineTime"
                    title="Tổng thời gian trực tuyến"
                    width={100}
                  />
                </ExcelExport>
              )}
            </CardContent>
          </Card>
        </ValidatorForm>
        {this.state.reportDay === true ? (
          <Grid container spacing={24}>
            <Grid item md={12}>
              {listReportPerformanceResult.length != 0 ? (
                listReportPerformanceResult[0].calls != 0 ? (
                  <Paper
                    style={{
                      marginTop: 15,
                      justifyContent: "center",
                      display: "flex",
                      backgroundColor: "#fff",
                      color: "#000",
                    }}>
                    <Chart
                      width={"100%"}
                      height={"900px"}
                      chartType="BarChart"
                      loader={<div>Loading Chart</div>}
                      data={outboundReport}
                      options={{
                        title: "Báo cáo năng suất máy lẻ ( Cuộc gọi ra )",
                        isStacked: true,
                        hAxis: {
                          title: "Cuộc gọi",
                        },
                        vAxis: {
                          title: "Máy lẻ",
                          minValue: 0,
                        },
                      }}
                      rootProps={{ "data-testid": "3" }}
                    />
                  </Paper>
                ) : (
                  <React.Fragment />
                )
              ) : (
                <React.Fragment />
              )}
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={24}>
            {listReportAgentAndGroupResult.length != 0 ? (
              listReportAgentAndGroupResult[0].calls != 0 ? (
                <Grid item md={12}>
                  <Paper
                    style={{
                      marginTop: 15,
                      justifyContent: "center",
                      display: "flex",
                      backgroundColor: "#fff",
                      color: "#000",
                    }}>
                    <Chart
                      width={"100%"}
                      height={"900px"}
                      chartType="BarChart"
                      loader={<div>Loading Chart</div>}
                      data={outboundReportAgent}
                      options={{
                        title:
                          "Báo cáo năng suất theo team và agent ( Cuộc gọi ra )",
                        isStacked: true,
                        hAxis: {
                          title: "Cuộc gọi",
                        },
                        vAxis: {
                          title: "Máy lẻ",
                          minValue: 0,
                        },
                      }}
                      rootProps={{ "data-testid": "3" }}
                    />
                  </Paper>
                </Grid>
              ) : (
                <React.Fragment />
              )
            ) : (
              <React.Fragment />
            )}
          </Grid>
        )}
        <Paper square style={{ marginTop: 15 }}>
          {this.state.reportDay == true ? (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Ngày
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Nhóm
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Mã điện thoại viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Mã đơn vị
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tên đơn vị
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Nghiệp vụ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tên điện thoại viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số cuộc
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng cuộc gọi kết nối
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số cuộc không trả lời
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số cuộc bận
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian thoại
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian thoại trung bình
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ ngắn nhất
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ dài nhất
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ trung bình
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số lần nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian tạm nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian trực tuyến
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: "#fff" }}>
                {listReportPerformanceResult
                  ? listReportPerformanceResult.map((row, key) => {
                      return (
                        <TableRow className={classes.row} key={key}>
                          {row.groups.date.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.date.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.date}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}
                          {row.groups.dateNTeam.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.dateNTeam.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.agent.group}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.code}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrg}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrgName}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrgBusiness}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.fullname}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.calls === 0 ? "-" : row.calls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalConnect === 0 ? "-" : row.totalConnect}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.noAnsweredCalls === 0
                              ? "-"
                              : row.noAnsweredCalls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.busyCalls === 0 ? "-" : row.busyCalls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {(row.totalTalkingTime === 0) |
                            (row.totalTalkingTime === null)
                              ? "-"
                              : row.totalTalkingTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.acd == null ? "-" : row.acd}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.minWrapupTime === null
                              ? "-"
                              : row.minWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.maxWrapupTime === null
                              ? "-"
                              : row.maxWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {(row.avgWrapupTime === 0) |
                            (row.avgWrapupTime === null)
                              ? "-"
                              : row.avgWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalBreak === 0 ? "-" : row.totalBreak}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalBreakTime === 0
                              ? "-"
                              : row.totalBreakTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalRespiteTime === 0
                              ? "-"
                              : row.totalRespiteTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalOnlineTime === 0
                              ? "-"
                              : row.totalOnlineTime}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          ) : (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Ngày
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Nhóm
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Mã điện thoại viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Mã đơn vị
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tên đơn vị
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Nghiệp vụ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tên điện thoại viên
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng số cuộc
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng cuộc gọi kết nối
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số cuộc không trả lời
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số cuộc bận
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian thoại
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian thoại trung bình
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ ngắn nhất
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ dài nhất
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Thời gian chờ trung bình
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Số lần nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian tạm nghỉ
                  </TableCell>
                  <TableCell
                    className={classes.head}
                    style={{
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "4px 4px 4px 4px",
                      textAlign: "center",
                    }}>
                    Tổng thời gian trực tuyến
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listReportAgentAndGroupResult
                  ? listReportAgentAndGroupResult.map((row, key) => {
                      return (
                        <TableRow className={classes.row} key={key}>
                          {row.groups.date.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.date.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.date}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}
                          {row.groups.dateNTeam.index === 0 ? (
                            <TableCell
                              component="th"
                              scope="row"
                              rowSpan={row.groups.dateNTeam.count}
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                                padding: "4px 4px 4px 4px",
                                textAlign: "center",
                              }}>
                              {row.agent.group}
                            </TableCell>
                          ) : (
                            <React.Fragment />
                          )}
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.code}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrg}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrgName}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.subOrgBusiness}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.agent.fullname}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.calls === 0 ? "-" : row.calls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalConnect === 0 ? "-" : row.totalConnect}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.noAnsweredCalls === 0
                              ? "-"
                              : row.noAnsweredCalls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.busyCalls === 0 ? "-" : row.busyCalls}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalTalkingTime === 0
                              ? "-"
                              : row.totalTalkingTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {(row.acd === 0) | (row.acd === null)
                              ? "-"
                              : row.acd}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.minWrapupTime === null
                              ? "-"
                              : row.minWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.maxWrapupTime === null
                              ? "-"
                              : row.maxWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {(row.avgWrapupTime === 0) |
                            (row.avgWrapupTime === null)
                              ? "-"
                              : row.avgWrapupTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalBreak === 0 ? "-" : row.totalBreak}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalBreakTime === 0
                              ? "-"
                              : row.totalBreakTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalRespiteTime === 0
                              ? "-"
                              : row.totalRespiteTime}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.totalOnlineTime === 0
                              ? "-"
                              : row.totalOnlineTime}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          )}
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
    "& p": {
      position: "absolute",
      top: "55px",
    },
  },
  form: {
    width: "100%",
  },
  rootDialog: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    overflowX: "auto",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#90a4ae",
    },
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  head: {
    backgroundColor: "#f2f2f2",
    position: "sticky",
    top: 65,
    zIndex: 1,
  },
  fab: {
    marginRight: 10,
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
});

ReportPerformance.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listReportPerformance: state.reportAgent.reportAgentPerformence,
  listCampaign: state.campaign.campaigns,
  listAgentGroups: state.agent.groupAgent,
  listAgents: state.agent.agents,
  loading: state.reportAgent.loading,
  listReportAgentAndGroup: state.reportAgent.reportAgentAndGroup,
});
const CampaignAction = connect(null, campaignAction)(ReportPerformance);
const AgentAction = connect(null, agentAction)(CampaignAction);
const ReportGroupAction = connect(null, groupReportAction)(AgentAction);
ReportPerformance = connect(
  mapStateToProps,
  mapActionsToProps
)(ReportGroupAction);
export default withStyles(styles)(ReportPerformance);
